enum Awareness {
  None = 0,
  Aware = 1,
  Unaware = 2,
}

export default Awareness;
